import { render, staticRenderFns } from "./TimerReduce.vue?vue&type=template&id=b8b212a8&scoped=true&"
import script from "./TimerReduce.vue?vue&type=script&lang=js&"
export * from "./TimerReduce.vue?vue&type=script&lang=js&"
import style0 from "./TimerReduce.vue?vue&type=style&index=0&id=b8b212a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b212a8",
  null
  
)

export default component.exports